import { api } from '@/lib/api';
import type { ModulePresentation, UpdateModuleInput } from './types';
import type { VendorModuleType } from '@/features/bookings/types';

/** Every module, hidden ones included — the console has to be able to switch them back on. */
export async function fetch_modules(): Promise<ModulePresentation[]> {
  const res = await api.get<{ items: ModulePresentation[] }>('/admin/modules');
  return res.data.items;
}

export async function update_module(
  module_type: VendorModuleType,
  input: UpdateModuleInput,
): Promise<ModulePresentation> {
  const res = await api.patch<ModulePresentation>(`/admin/modules/${module_type}`, input);
  return res.data;
}

/** Upload artwork, then attach the returned key. Mirrors the category and banner flows. */
export async function upload_module_icon(file: File): Promise<{ icon_s3_key: string }> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<{ icon_s3_key: string }>('/admin/modules/icon', form);
  return res.data;
}
